import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import useWindowSize from '../../hooks/useWindowSize';
// import PropTypes from 'prop-types';
import * as AppPropTypes from '../../lib/PropTypes';

import Button from '../buttons/Button';
import Logo from '../icons/Logo';
import OtherLocales from '../partials/OtherLocales';
import FooterNHL from '../themes/nhl/Footer';

import styles from '../../../styles/pages/calltheshot.module.scss';

const propTypes = {
    page: AppPropTypes.page.isRequired,
};

function CalltheshotPage({ page }) {
    const { height } = useWindowSize();
    const intl = useIntl();

    const currentUrl = `${window.location.origin}${window.location.pathname}`;

    const {
        urls,
        contests = [
            {
                url: currentUrl
                    .replace('v2.calltheshot.ca.test', 'bp.calltheshot.ca.test')
                    .replace('v2', 'bp.v2'),
                logo: 'nhl_boston_pizza',
                color: '#041841',
                borderColor: '#385086',
                label: intl.formatMessage({
                    defaultMessage: 'I play from Boston Pizza',
                    description: 'NHL button label',
                }),
            },
            {
                url: currentUrl
                    .replace('v2.calltheshot.ca.test', 'molson.calltheshot.ca.test')
                    .replace('v2', 'molson.v2'),
                logo: 'nhl_molson',
                color: '#a11725',
                label: intl.formatMessage({
                    defaultMessage: 'I play from home',
                    description: 'NHL button label',
                }),
            },
        ],
    } = page || {}; // @TODO backend

    return (
        <div className={styles.container} style={{ minHeight: height }}>
            <div className={styles.inner}>
                <div className={styles.title}>
                    <FormattedMessage defaultMessage="Welcome" description="CTS home title" />
                </div>
                <div className={styles.subtitle}>
                    <FormattedMessage
                        defaultMessage="Choose your game"
                        description="CTS home subtitle"
                    />
                </div>
                <div className={styles.contests}>
                    {contests.map(({ url, logo, label, color, borderColor }, contestIndex) => (
                        <Button
                            key={`contest-${contestIndex + 1}`}
                            href={url}
                            direct
                            className={styles.contest}
                        >
                            <span
                                className={styles.contestInner}
                                style={{ backgroundColor: color, borderColor }}
                            >
                                <Logo component={logo} className={styles.logo} />
                                <span className={styles.label}>{label}</span>
                                <span className={styles.pill}>
                                    <FormattedMessage
                                        defaultMessage="Play"
                                        description="Button label"
                                    />
                                </span>
                            </span>
                        </Button>
                    ))}
                </div>
                <OtherLocales className={styles.otherLocales} pageUrls={urls} />
            </div>
            <FooterNHL className={styles.footer} />
        </div>
    );
}

CalltheshotPage.propTypes = propTypes;

export default CalltheshotPage;
